/**
 * Centralized constants for the frontend application.
 * Update these values in one place to affect the entire application.
 */

// Shopify API configuration (keep in sync with backend)
export const SHOPIFY_API_VERSION = "2026-01";

// UI timing constants
export const UI_TIMING = {
  toastDurationMs: 5000,
  copyFeedbackMs: 2000,
} as const;

// Brand colors (defined in tailwind.config.js, referenced here for non-Tailwind usage)
export const BRAND_COLORS = {
  primary: "#36646C",
} as const;
